import { FC, createElement } from "react";
import usePopupWindow from "common/hooks/usePopUpWindow";
import { EmailButtonStyled } from "./ShareButton.styled";
import { FaWhatsapp } from "react-icons/fa";
import { useDevice } from "common/hooks/useDevice";
import EmailIcon from "../../common/icons/email";
import FacebookIcon from "../../common/icons/facebook";
import TwitterIcon from "../../common/icons/twitter";

type IconProps = {
  type: string;
  publication: {
    url: string;
  };
  article: {
    title: string;
  };
};

const icons: {
  [key: string]: FC<IconProps>;
} = {
  twitter: TwitterIcon,
  email: EmailIcon,
  facebook: FacebookIcon,
  whatsApp: FaWhatsapp,
};

type Props = {
  type: string;
  url: string;
  nativeSharingUrl?: string;
  nativeSharingTitle?: string;
  nativeSharingText?: string;
};

const ShareButton: FC<Props> = ({
  url,
  type,
  nativeSharingUrl,
  nativeSharingTitle,
  nativeSharingText,
}) => {
  const { nativeSharing } = useDevice();

  const popupWindow = usePopupWindow();

  const handleTwitterShareClick = (): void => {
    if (type === "email") {
      window.location.assign(url);
    } else {
      popupWindow(url);
      {
        /* if (!nativeSharing) {
        popupWindow(url);
      } else {
        const shareData = {
          title: nativeSharingTitle,
          text: nativeSharingText,
          url: nativeSharingUrl,
        };
        navigator.share(shareData);
      }*/
      }
    }
  };

  return (
    <>
      <EmailButtonStyled
        shareType={type}
        onClick={() => handleTwitterShareClick()}
      >
        {createElement(icons[type])}
      </EmailButtonStyled>
    </>
  );
};

export default ShareButton;
